module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-229.f395526a.svg";